let dLn = 'mo'
let lnOptions = ['en','mo']
let ln = localStorage.getItem('defaultLang') // navbar
ln = (ln===null) ? dLn : (lnOptions.indexOf(ln) !== -1) ? ln : dLn


let devlopment = {
    url: 'https://api.9999.mn/', //http://localhost:3001/
    sessionkey: 'sanhivtest',          //http://macpapi.virtualstacks-demosite.com:3001/
    CATEGORY_FOLDER: 'cim',
    PRODUCT_FOLDER: 'pim',
    PROFILE_FOLDER: 'profile',
    PERCENTAGE: 11,
    PMT_FOLDER: 'pmt',
    INVOICE_FOLDER: 'invoice',
    BANKQR_FOLDER: 'bankQR',
    lng:ln
}

let prodcution = {
    url: 'http://localhost:3001/',
    sessionkey: 'sanhivtest',
    CATEGORY_FOLDER: 'cim',
    PRODUCT_FOLDER: 'pim',
    PROFILE_FOLDER: 'profile',
    PERCENTAGE: 11,
    PMT_FOLDER: 'pmt',
    INVOICE_FOLDER: 'invoice',
    BANKQR_FOLDER: 'bankQR',
    lng:ln

}



let config = (process.env.REACT_APP_ENVIRONMENT==='prodcution') ? prodcution : devlopment
export default config;
